<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="primary--text font-weight-medium"
          >Modo oscuro</v-list-item-title
        >
      </v-list-item-content>
      <v-list-item-action>
        <v-switch
          v-model="darkMode"
          @change="darkModeUpdated"
          hide-details
        ></v-switch>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
export default {
  data: () => ({
    darkMode: false
  }),
  methods: {
    async darkModeUpdated() {
      try {
        await this.$http.patch("practitioner/" + this.practitionerLogged.id, {
          darkMode: this.darkMode
        });
        this.$vuetify.theme.dark = this.darkMode;
        this.$store.dispatch("authPractitioner/setPractitioner", {
          darkMode: this.darkMode
        });
      } catch (err) {}
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  },
  mounted() {
    this.darkMode = !!this.practitionerLogged.darkMode;
  }
};
</script>

<style></style>
